var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-header'),_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"content"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c(Component,{tag:"component"})],1)]}}])})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }